import { useState } from 'react'
import { FaPencilAlt } from 'react-icons/fa'
import { FiList, FiXCircle } from 'react-icons/fi'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'
import ParcelsModal from '../ParcelsModal'
import FormFinanceEntry from '../Form/FormFinanceEntry'
import TimestampToString from '../../../shared/functions/TimestampToString'
import { FINANCE_STATUS_LABEL } from '../../../shared/constants/financePaymentMethods'
import useFlashMessage from '../../../hooks/useFlashMessage'

import '../Finance.css'

const ORIGIN_LABEL = {
    purchaseOrder: 'Pedido de Compra',
    productionOrder: 'Ordem de Produção',
    order: 'Pedido',
    recorrente: 'Conta Fixa',
    avulso: null,
}

function ListFinanceEntryRow({ dataArray, type, categories, myPermissionEdit, myPermissionDelete, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const { timeStampToDDMMAAAA } = TimestampToString()

    const [parcelsEntry, setParcelsEntry] = useState(null)
    const [editingEntry, setEditingEntry] = useState(null)
    const [cancelEntry, setCancelEntry] = useState(null)
    const [deleteEntry, setDeleteEntryState] = useState(null)

    async function confirmCancel() {
        let msgType = 'success'
        const data = await api.patch(`/finance/entry/${cancelEntry._id}/cancel`, {}, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => response.data).catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)
        setCancelEntry(null)
        if (msgType !== 'error') handleOnSuccess()
    }

    async function confirmDelete() {
        let msgType = 'success'
        const data = await api.delete(`/finance/entry/${deleteEntry._id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => response.data).catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)
        setDeleteEntryState(null)
        if (msgType !== 'error') handleOnSuccess()
    }

    return (
        <div>
            {dataArray.map((entry) => {
                const openParcel = entry.parcels.find((p) => p.status === 'aberto' || p.status === 'atrasado')
                const hasPaidParcel = entry.parcels.some((p) => p.status === 'pago')
                const originLabel = ORIGIN_LABEL[entry.origin?.kind]

                return (
                    <div key={entry._id} className="pg-item">
                        <div className="pg-item-main fin-row-main">
                            <div className="fin-row-header">
                                <span className="fin-row-desc">{entry.description}</span>
                                {entry.counterpart?.name && <span className="fin-row-meta">{entry.counterpart.name}</span>}
                            </div>
                            <div className="fin-row-meta">
                                {entry.parcels.length > 1 && <span>{entry.parcels.length} parcelas</span>}
                                {originLabel && (
                                    entry.origin.kind === 'order' ? (
                                        <span className="fin-row-origin fin-row-origin-link" onClick={() => window.open(`/order/report/${entry.origin.refId}`, '_blank')}>
                                            {originLabel} — {entry.origin.refCode}
                                        </span>
                                    ) : (
                                        <span className="fin-row-origin">{originLabel} — {entry.origin.refCode}</span>
                                    )
                                )}
                            </div>
                            <div className="fin-row-categories">
                                {entry.allocations.map((a, i) => a.category && (
                                    <span key={i} className="fin-tag">{a.category.name}</span>
                                ))}
                            </div>
                        </div>

                        <div className="fin-row-value-col">
                            <span className="fin-row-value">R$ {entry.totalValue.toFixed(2)}</span>
                            {openParcel && <span className="fin-row-due">próx. venc.: {timeStampToDDMMAAAA(new Date(openParcel.dueDate).toISOString())}</span>}
                            <span className={`fin-status fin-status-${entry.status}`}>{FINANCE_STATUS_LABEL[entry.status]}</span>
                        </div>

                        <div className="shd-row-box-item-action">
                            <FiList className="shd-icon-row-edit" title="Ver Parcelas" onClick={() => setParcelsEntry(entry)} />
                            {myPermissionEdit && (
                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => setEditingEntry(entry)} />
                            )}
                            {myPermissionEdit && entry.status !== 'cancelado' && entry.status !== 'pago' && (
                                <FiXCircle className="shd-icon-row-edit" title="Cancelar" onClick={() => setCancelEntry(entry)} />
                            )}
                            {myPermissionDelete && !hasPaidParcel && (
                                <FiXCircle className="shd-icon-row-trash" title="Apagar" onClick={() => setDeleteEntryState(entry)} />
                            )}
                        </div>
                    </div>
                )
            })}

            <Modal
                modalStatus={!!parcelsEntry}
                changeStatus={() => setParcelsEntry(null)}
                w={55}
                content={
                    parcelsEntry && (
                        <ParcelsModal
                            entry={parcelsEntry}
                            myPermissionEdit={myPermissionEdit}
                            handleOnSuccess={() => { setParcelsEntry(null); handleOnSuccess() }}
                        />
                    )
                }
            />

            <Modal
                modalStatus={!!editingEntry}
                changeStatus={() => setEditingEntry(null)}
                w={70}
                content={
                    editingEntry && (
                        <FormFinanceEntry
                            type={type}
                            categories={categories}
                            editingEntry={editingEntry}
                            btCancelAction={() => setEditingEntry(null)}
                            handleOnSuccess={() => { setEditingEntry(null); handleOnSuccess() }}
                        />
                    )
                }
            />

            <ConfirmDeleteModal
                modalStatus={!!cancelEntry}
                changeStatus={() => setCancelEntry(null)}
                onConfirm={confirmCancel}
                title="Cancelar lançamento"
                message="Deseja realmente cancelar as parcelas em aberto desse lançamento?"
                itemName={cancelEntry?.description}
                confirmText="Cancelar Lançamento"
            />

            <ConfirmDeleteModal
                modalStatus={!!deleteEntry}
                changeStatus={() => setDeleteEntryState(null)}
                onConfirm={confirmDelete}
                message="Deseja realmente apagar esse lançamento?"
                itemName={deleteEntry?.description}
            />
        </div>
    )
}

export default ListFinanceEntryRow
